export const ProductExpansionColumns = [
    {
        accessorKey: 'oid',
        header: 'Product Service OID',
    },
];

export const productExpansionUploadWarning = {
    title: 'Upload New File',
    body: 'This will clear the list of products associated with this product expansion go-live. If a previous upload established configurations not in the new list, those must be removed manually from product configuration.',
};
